var map = {
	"./": 318,
	"./Content": 982,
	"./Content/": 982,
	"./Content/AllSportsGrid": 983,
	"./Content/AllSportsGrid.js": 983,
	"./Content/Announcement": 959,
	"./Content/Announcement/": 959,
	"./Content/Announcement/Announcement.dictionary": 902,
	"./Content/Announcement/Announcement.dictionary.json": 902,
	"./Content/Announcement/Announcement.module.scss": 984,
	"./Content/Announcement/components/AnnouncementItem": 1051,
	"./Content/Announcement/components/AnnouncementItem.tsx": 1051,
	"./Content/Announcement/components/AnnouncementTable": 1113,
	"./Content/Announcement/components/AnnouncementTable.tsx": 1113,
	"./Content/Announcement/components/FilterByTime": 1114,
	"./Content/Announcement/components/FilterByTime.tsx": 1114,
	"./Content/Announcement/get-time-to-fetch-utils": 1115,
	"./Content/Announcement/get-time-to-fetch-utils.ts": 1115,
	"./Content/Announcement/index": 959,
	"./Content/Announcement/index.tsx": 959,
	"./Content/Announcement/types": 901,
	"./Content/Announcement/types.ts": 901,
	"./Content/Announcement/utils/get-announcements-and-options-utils": 1072,
	"./Content/Announcement/utils/get-announcements-and-options-utils.spec": 1153,
	"./Content/Announcement/utils/get-announcements-and-options-utils.spec.js": 1153,
	"./Content/Announcement/utils/get-announcements-and-options-utils.ts": 1072,
	"./Content/Announcement/utils/get-breadcrumbs-by-match-utils": 1050,
	"./Content/Announcement/utils/get-breadcrumbs-by-match-utils.ts": 1050,
	"./Content/MatchCenter": 903,
	"./Content/MatchCenter/": 903,
	"./Content/MatchCenter/MatchCenter.module.scss": 985,
	"./Content/MatchCenter/index": 903,
	"./Content/MatchCenter/index.tsx": 903,
	"./Content/SportGrid": 904,
	"./Content/SportGrid/": 904,
	"./Content/SportGrid/SportGrid.module.scss": 986,
	"./Content/SportGrid/TournamentTable": 936,
	"./Content/SportGrid/TournamentTable.js": 936,
	"./Content/SportGrid/index": 904,
	"./Content/SportGrid/index.jsx": 904,
	"./Content/StageGrid": 905,
	"./Content/StageGrid/": 905,
	"./Content/StageGrid/StageGrid": 883,
	"./Content/StageGrid/StageGrid.module.scss": 937,
	"./Content/StageGrid/StageGrid.tsx": 883,
	"./Content/StageGrid/index": 905,
	"./Content/StageGrid/index.ts": 905,
	"./Content/StreamGrid": 906,
	"./Content/StreamGrid/": 906,
	"./Content/StreamGrid/index": 906,
	"./Content/StreamGrid/index.ts": 906,
	"./Content/components/GridHeader": 861,
	"./Content/components/GridHeader.tsx": 861,
	"./Content/components/SportsGrid": 870,
	"./Content/components/SportsGrid.module.scss": 900,
	"./Content/components/SportsGrid.tsx": 870,
	"./Content/components/TournamentTable": 882,
	"./Content/components/TournamentTable.js": 882,
	"./Content/index": 982,
	"./Content/index.tsx": 982,
	"./Live": 1154,
	"./Live.dictionary": 342,
	"./Live.dictionary.json": 342,
	"./Live.explanation": 1155,
	"./Live.explanation.ts": 1155,
	"./Live.tsx": 1154,
	"./LiveDeferred": 373,
	"./LiveDeferred.tsx": 373,
	"./actions": 126,
	"./actions/": 126,
	"./actions/index": 126,
	"./actions/index.js": 126,
	"./actions/liveHub": 115,
	"./actions/liveHub.ts": 115,
	"./constants": 561,
	"./constants.ts": 561,
	"./index": 318,
	"./index.tsx": 318,
	"./reducer": 296,
	"./reducer/": 296,
	"./reducer/entities": 354,
	"./reducer/entities.ts": 354,
	"./reducer/index": 296,
	"./reducer/index.js": 296,
	"./reducer/presentation": 355,
	"./reducer/presentation.js": 355,
	"./selectors/entities": 122,
	"./selectors/entities.ts": 122,
	"./selectors/gridPresentation": 199,
	"./selectors/gridPresentation.ts": 199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1275;
module.exports = webpackContext;